import clsx from "clsx";
import PropTypes from "prop-types";
import * as React from "react";
import { ScrollArea as BaseScrollArea } from "@base-ui/react/scroll-area";
import css from "./ScrollArea.module.css";

const ScrollArea = React.forwardRef(
  ({ orientation = "vertical", className, children, ...rest }, ref) => {
    const showVertical = orientation === "vertical" || orientation === "both";
    const showHorizontal =
      orientation === "horizontal" || orientation === "both";

    return (
      <BaseScrollArea.Root
        ref={ref}
        className={clsx(css.root, className)}
        {...rest}
      >
        <BaseScrollArea.Viewport className={css.viewport}>
          {children}
        </BaseScrollArea.Viewport>
        {showVertical && (
          <BaseScrollArea.Scrollbar
            orientation="vertical"
            className={css.scrollbar}
          >
            <BaseScrollArea.Thumb className={css.thumb} />
          </BaseScrollArea.Scrollbar>
        )}
        {showHorizontal && (
          <BaseScrollArea.Scrollbar
            orientation="horizontal"
            className={clsx(css.scrollbar, css.horizontal)}
          >
            <BaseScrollArea.Thumb className={css.thumb} />
          </BaseScrollArea.Scrollbar>
        )}
        {orientation === "both" && (
          <BaseScrollArea.Corner className={css.corner} />
        )}
      </BaseScrollArea.Root>
    );
  },
);

ScrollArea.displayName = "ScrollArea";

ScrollArea.propTypes = {
  orientation: PropTypes.oneOf(["vertical", "horizontal", "both"]),
  className: PropTypes.string,
  children: PropTypes.node,
};

export default ScrollArea;
